module.exports = __webpack_public_path__ + "static/media/cheackMark.4b0b27ea.png";